import React, { useEffect, useMemo, useState } from "react";
import { Container, Table, Pagination, } from "react-bootstrap";
import { FiPlus, FiEdit, FiHome, FiChevronRight } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { toast } from "react-hot-toast";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function ClassandSection() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const {
    loading,
    error,
    classsectionList = [],
  } = useSelector((state) => state.classsection);

  useEffect(() => {
    setIsLoading(true);

    dispatch(fetchStandardSection())
      .unwrap()
      .catch(({ message }) => {
        console.error(message);
        toast.error("Failed to fetch standard & section");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [dispatch]);


  const rows = useMemo(() => {
    return classsectionList.map((item) => {
      const uniqueSections = [
        ...new Set((item.sectionId || []).map((s) => s.name)),
      ];

      return {
        id: item._id,
        standard: item.standardId?.name || "-",
        sections: uniqueSections.join(", "),
      };
    });
  }, [classsectionList]);


  const totalPages = Math.ceil(rows.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;

  const paginatedData = rows.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  return (
    <>
      <div className="page-header">

        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>
            <FiChevronRight className="separator" />

            <span className="active">Class and Section</span>
          </div>

          <Link to="/institute/add-classandsection"
            className="add-btn"
          >
            <FiPlus />
            Add New
          </Link>

        </div>

      </div>
      <Container fluid>
        <div className="staff-card">
          <div className="table-responsive">
            <Table className="staff-table align-middle">
              <thead>
                <tr>
                  <th className="text-center">#</th>
                  <th className="text-center">Standard</th>
                  <th className="text-center">Sections</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  Array.from({ length: 8 }).map((_, index) => (
                    <tr key={index}>
                      <td className="text-center">
                        <Skeleton width={20} />
                      </td>

                      <td className="text-center">
                        <Skeleton width={120} />
                      </td>

                      <td className="text-center">
                        <Skeleton width={220} />
                      </td>

                      <td className="text-center">
                        <div className="d-flex justify-content-center">
                          <Skeleton width={38} height={38} borderRadius={10} />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : error ? (
                  <tr>
                    <td colSpan={4} className="text-center text-danger">
                      {error}
                    </td>
                  </tr>
                ) : paginatedData.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="text-center py-4">
                      No data found!
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((row, index) => (
                    <tr key={row.id}>
                      <td className="text-center">
                        {startIndex + index + 1}
                      </td>

                      <td className="text-center">
                        {row.standard}
                      </td>

                      <td className="text-center">
                        {row.sections}
                      </td>

                      <td className="text-center">
                        <button
                          className="edit-btn"
                          onClick={() =>
                            navigate(`/institute/edit-classandsection/${row.id}`)
                          }
                        >
                          <FiEdit style={{ fontSize: "15px" }} />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>

          <div className="d-flex justify-content-end my-3">
            <Pagination className="mb-0">

              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              />

              {Array.from({ length: totalPages }, (_, index) => {
                const page = index + 1;

                // Show first page, last page, and pages around current page
                if (
                  page === 1 ||
                  page === totalPages ||
                  (page >= currentPage - 1 && page <= currentPage + 1)
                ) {
                  return (
                    <Pagination.Item
                      key={page}
                      active={page === currentPage}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </Pagination.Item>
                  );
                }

                // Left dots
                if (page === currentPage - 2) {
                  return <Pagination.Ellipsis key={`left-${page}`} disabled />;
                }

                // Right dots
                if (page === currentPage + 2) {
                  return <Pagination.Ellipsis key={`right-${page}`} disabled />;
                }

                return null;
              })}

              <Pagination.Next
                disabled={currentPage === totalPages || totalPages === 0}
                onClick={() => setCurrentPage((p) => p + 1)}
              />

            </Pagination>
          </div>
        </div>
      </Container>
    </>
  );
}
